export const gradients = `
    .image-overlay-gradient {
        background: linear-gradient(180deg, rgba(102, 95, 107, 0) 0%, rgba(54, 49, 57, 0.85) 100%);
    }
`